// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"43955783","295":"bf489f1f","355":"23034f16","380":"440416c9","552":"80dba28f","661":"8870d1b0","728":"560b8cff","735":"d41d8489","737":"5cb904a6","853":"2f6cefe0","902":"1c008403"}[chunkId] + ".chunk.js";
};